import { Router, NavigationEnd, ActivatedRoute } from "@angular/router";
import { filter, map } from "rxjs";
import { Component, Inject, PLATFORM_ID } from "@angular/core";
import { Meta, Title } from "@angular/platform-browser";
import { isPlatformServer } from "@angular/common";
import { TransferState, makeStateKey } from "@angular/platform-browser";


const META_TAGS_KEY = makeStateKey<boolean>("meta-tags-set");

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent {
  title = "illusbook-web-app";

  constructor(
    private router: Router,
    private titleService: Title,
    private metaService: Meta,
    private transferState: TransferState,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    if (isPlatformServer(this.platformId)) {
      if (!this.transferState.hasKey(META_TAGS_KEY)) {
        // this.setMetaTags();
        this.transferState.set(META_TAGS_KEY, true);
      }
    }
    
    this.router.events
  .pipe(filter(e => e instanceof NavigationEnd))
  .subscribe(() => {
    if (!location.hash) {
      // normal page navigation
      setTimeout(() => {
        window.scrollTo({ top: 0, left: 0 });
      }, 50);
      return;
    }

    // anchor navigation
    setTimeout(() => {
      const id = location.hash.replace('#', '');
      const el = document.getElementById(id);
      el?.scrollIntoView({ behavior: 'auto', block: 'start' });
    }, 100); // delay is IMPORTANT for iOS
  });
  }

  ngOnInit() {
    // this.titleService.setTitle("Awesome Page | Illusbook");
    // this.metaService.addTags([
    //   {
    //     name: "description",
    //     content: "This is a super cool page about awesome stuff.",
    //   },
    //   { property: "og:title", content: "Awesome Page | Illusbook" },
    //   {
    //     property: "og:description",
    //     content: "Learn about amazing content in this post.",
    //   },
    //   {
    //     property: "og:image",
    //     content:
    //       "https://firebasestorage.googleapis.com/v0/b/illusbookdata.appspot.com/o/uploads%2FA%20boy%20studying%20with%20the%20laptop%20concept%20illustration%2FA%20boy%20studying%20with%20the%20laptop%20concept%20illustration.jpg?alt=media&token=178effc4-0546-41da-a285-001f1b107076",
    //   },
    //   { property: "og:url", content: window.location.href },
    //   { name: "twitter:card", content: "summary_large_image" },
    // ]);

    // this.router.events
    //   .pipe(
    //     filter((event) => event instanceof NavigationEnd),
    //     map(() => {
    //       let route: ActivatedRoute = this.router.routerState.root;
    //       let routeTitle = "";
    //       while (route!.firstChild) {
    //         route = route.firstChild;
    //       }
    //       if (route.snapshot.data["title"]) {
    //         routeTitle = route!.snapshot.params["title"]
    //           ? route!.snapshot.params["title"]
    //           : route!.snapshot.data["title"];
    //       }
    //       return routeTitle;
    //     })
    //   )
    //   .subscribe((title: string) => {
    //     if (title) {
    //       this.titleService.setTitle(`Illusbook - ${title}`);
    //     }
    //   });
    
  }

  // private setMetaTags() {
  //   this.titleService.setTitle("Home | IllusBook");
  //   this.metaService.updateTag({
  //     name: "description",
  //     content: "Your creative community.",
  //   });
  //   this.metaService.updateTag({
  //     name: "keywords",
  //     content: "books, community, stories",
  //   });
  // }
}
